import { OrganizationEntityPriority as OrganizationEntityPriorityEnum } from "@common/types/organizationEntity";
import {
    TaskPriorityLowIcon,
    TaskPriorityMediumIcon,
    TaskPriorityHighIcon,
} from "@icons/taskStatuses";

export const ORGANIZATION_ENTITY_PRIORITY_CONFIG: Record<
    OrganizationEntityPriorityEnum,
    {
        Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
        label: string;
        className?: string;
    }
> = {
    [OrganizationEntityPriorityEnum.LOW]: {
        Icon: TaskPriorityLowIcon,
        label: "Low",
        className: undefined,
    },
    [OrganizationEntityPriorityEnum.MEDIUM]: {
        Icon: TaskPriorityMediumIcon,
        label: "Medium",
        className: "icon-color-revert",
    },
    [OrganizationEntityPriorityEnum.HIGH]: {
        Icon: TaskPriorityHighIcon,
        label: "High",
        className: "icon-color-revert",
    },
    [OrganizationEntityPriorityEnum.URGENT]: {
        Icon: TaskPriorityHighIcon,
        label: "Urgent",
        className: "icon-color-revert",
    },
};
